var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { width: "700" },
      model: {
        value: _vm.addShareUserDialog,
        callback: function ($$v) {
          _vm.addShareUserDialog = $$v
        },
        expression: "addShareUserDialog",
      },
    },
    [
      _c("customDialog", {
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [
                _vm._v(" " + _vm._s(_vm.ts("addShareUserWith")) + " "),
                _c("button", { attrs: { id: "dialog_exit" } }, [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/popup_close.png"),
                      id: "btn_img",
                    },
                    on: { click: _vm.closeShareUserDialog },
                  }),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "body",
            fn: function () {
              return [
                _c(
                  "v-row",
                  { staticClass: "ma-0 pa-0", attrs: { justify: "center" } },
                  [
                    _c(
                      "v-col",
                      { staticClass: "ma-0 pa-0", attrs: { cols: "10" } },
                      [
                        _c(
                          "v-col",
                          {
                            staticClass: "ma-0 pa-0 pb-3",
                            attrs: { cols: "12", align: "left" },
                          },
                          [
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 pb-5",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-2 pl-0 pr-0",
                                    attrs: { id: "add_box", align: "center" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "5" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.ts("nameOfThePersonToInvite")
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "7" },
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.userName,
                                              expression: "userName",
                                            },
                                          ],
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            id: "user_input",
                                            placeholder:
                                              _vm.ts("shareUserName"),
                                          },
                                          domProps: { value: _vm.userName },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.userName = $event.target.value
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-2 pl-0 pr-0",
                                    attrs: { id: "add_box", align: "center" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "5" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.t("emailAddress")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "7" },
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.mailAddress,
                                              expression: "mailAddress",
                                            },
                                          ],
                                          staticStyle: { width: "100%" },
                                          attrs: {
                                            id: "user_input",
                                            placeholder: _vm.t("emailAddress"),
                                          },
                                          domProps: { value: _vm.mailAddress },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.mailAddress =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-2 pl-0 pr-0",
                                    attrs: { id: "add_box", align: "center" },
                                  },
                                  [
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "5" },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.ts("authority")) +
                                            " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-col",
                                      {
                                        staticClass: "ma-0 pa-0",
                                        attrs: { cols: "7", align: "right" },
                                      },
                                      [
                                        _c(
                                          "v-col",
                                          {
                                            staticClass: "ma-0 pa-0",
                                            staticStyle: { width: "12rem" },
                                            attrs: { cols: "auto" },
                                          },
                                          [
                                            _c("v-select", {
                                              attrs: {
                                                "background-color": "#272727",
                                                dark: "",
                                                items: _vm.userStatus,
                                                dense: "",
                                                "hide-details": "",
                                                outlined: "",
                                                "item-text": "label",
                                                "item-value": "value",
                                              },
                                              model: {
                                                value: _vm.selectedUserStatus,
                                                callback: function ($$v) {
                                                  _vm.selectedUserStatus = $$v
                                                },
                                                expression:
                                                  "selectedUserStatus",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "v-col",
                              {
                                staticClass: "ma-0 pa-0 mt-10",
                                attrs: { cols: "12" },
                              },
                              [
                                _c(
                                  "v-row",
                                  {
                                    staticClass: "ma-0 pa-0",
                                    attrs: {
                                      align: "center",
                                      justify: "center",
                                    },
                                  },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-2",
                                        attrs: {
                                          width: "8rem",
                                          height: "auto",
                                          id: "grey_btn",
                                          elevation: "0",
                                        },
                                        on: { click: _vm.closeShareUserDialog },
                                      },
                                      [
                                        _vm._v(
                                          " " + _vm._s(_vm.t("cancel")) + " "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "ma-0 pa-2 ml-2",
                                        attrs: {
                                          loading: _vm.loading,
                                          width: "8rem",
                                          height: "auto",
                                          id: "blue_btn",
                                          elevation: "0",
                                        },
                                        on: { click: _vm.addShareUser },
                                      },
                                      [_vm._v(" " + _vm._s(_vm.t("add")) + " ")]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }